export const blogData = [
  {
    id: 1,
    title: '',
    description: '',
    date: '',
    image: '',
    url: '',
  },
];
